export const RENEWAL_TAGS = {
  FAMILIES: "RenewalFamilies",
  FAMILY: "RenewalFamily",
} as const;
